import styled from "styled-components";

export const CommunicationNote = styled.span`
  padding: 1rem;
  display: block;
  background-color: ${props => props.color || "green"};
  color: white;
  border-radius: 5px;
  margin-top: 10px;

  svg {
    margin-right: 5px;
  }
`;
